export enum GameTagsQueryKeys {
  Primary = '/game-tags',
}
